import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react';

interface NotCustomerUsersContextType {
  includeNotCustomerUsers: boolean;
  setIncludeNotCustomerUsers: (value: boolean) => void;
}

const NotCustomerUsersContext = createContext<
  NotCustomerUsersContextType | undefined
>(undefined);

export const NotCustomerUsersProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [includeNotCustomerUsers, setIncludeNotCustomerUsers] =
    useState<boolean>(false);

  return (
    <NotCustomerUsersContext.Provider
      value={{ includeNotCustomerUsers, setIncludeNotCustomerUsers }}
    >
      {children}
    </NotCustomerUsersContext.Provider>
  );
};

export const useNotCustomerUsers = (): NotCustomerUsersContextType => {
  const context = useContext(NotCustomerUsersContext);
  if (context === undefined) {
    throw new Error(
      'useNotCustomerUsers must be used within a NotCustomerUsersProvider',
    );
  }
  return context;
};
